import { render } from "./course.vue?vue&type=template&id=4788b3f1&scoped=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"

import "./course.vue?vue&type=style&index=0&id=4788b3f1&scoped=true&lang=css"

import exportComponent from "D:\\project\\xiongmao-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4788b3f1"]])

export default __exports__